import React from "react";
import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import {DISCOUNT_TYPES} from "../../../Constants/Constants";

const labelClasses = "btn btn-outline btn-outline-dashed btn-outline-default d-flex text-start p-6";
export default function () {
  const {product, dispatch, errors} = useNewProduct();

  return (
    <>
      <div className="fv-row mb-10">
        <label className="fs-6 fw-bold mb-2">Discount Type
          <i className="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
             title="Select a discount type that will be applied to this product">
          </i>
        </label>
        <div
          className="row row-cols-1 row-cols-md-3 row-cols-lg-1 row-cols-xl-3 g-9"
          data-kt-buttons="true"
          data-kt-buttons-target="[data-kt-button='true']"
        >
          <div className="col">
            <label
              className={`${labelClasses}${product.discount == DISCOUNT_TYPES.NO_DISCOUNT ? ' active' : ''}`}
              data-kt-button="true"
            >
            <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
              <input
                className="form-check-input"
                type="radio"
                name="discount_option"
                onChange={e => dispatch({
                  type: TYPES.SET_PRODUCT,
                  payload: {...product, discount: DISCOUNT_TYPES.NO_DISCOUNT}
                })}
                checked={product.discount == DISCOUNT_TYPES.NO_DISCOUNT}
              />
            </span>
              <span className="ms-5">
                <span className="fs-4 fw-bolder text-gray-800 d-block">
                  No Discount
                </span>
              </span>
            </label>
          </div>
          <div className="col">
            <label
              className={`${labelClasses}${product.discount == DISCOUNT_TYPES.PERCENTAGE ? ' active' : ''}`}
              data-kt-button="true"
            >
              <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                <input
                  className="form-check-input"
                  type="radio"
                  name="discount_option"
                  onChange={e => dispatch({
                    type: TYPES.SET_PRODUCT,
                    payload: {...product, discount: DISCOUNT_TYPES.PERCENTAGE}
                  })}
                  checked={product.discount == DISCOUNT_TYPES.PERCENTAGE}
                />
              </span>
              <span className="ms-5">
                    <span className="fs-4 fw-bolder text-gray-800 d-block">
                      Percentage %
                    </span>
                </span>
            </label>
          </div>
          <div className="col">
            <label
              className={`${labelClasses}${product.discount == DISCOUNT_TYPES.FIXED ? ' active' : ''}`}
              data-kt-button="true"
            >
                <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="discount_option"
                    onChange={e => dispatch({
                      type: TYPES.SET_PRODUCT,
                      payload: {...product, discount: DISCOUNT_TYPES.FIXED}
                    })}
                    checked={product.discount == DISCOUNT_TYPES.FIXED}
                  />
                </span>
              <span className="ms-5">
                  <span className="fs-4 fw-bolder text-gray-800 d-block">
                    Fixed Price
                  </span>
                </span>
            </label>
          </div>
        </div>
      </div>

      {product.discount === DISCOUNT_TYPES.PERCENTAGE && (
        <div className="mb-10 fv-row">
          <label className="form-label">Set Discount Percentage</label>
          <div className="d-flex flex-column text-center mb-5">
            <span className="fw-bolder fs-4 mt-1 ms-2">{product.discount_percentage || 0}%</span>
            <input
              type="range"
              className="form-range"
              onChange={e => dispatch({
                type: TYPES.SET_PRODUCT,
                payload: {...product, discount_percentage: e.target.value}
              })}
              value={product?.discount_percentage || 0}
            />
            {
              errors?.discount_percentage && (
                <div className="fs-7 mb-7 text-danger">{errors.discount_percentage}</div>
              )
            }
          </div>
        </div>
      )}

      {product.discount === DISCOUNT_TYPES.FIXED && (
        <div className="mb-10 fv-row">
          <label className="form-label">Fixed Discounted Price</label>
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Discounted price"
            onChange={e => dispatch({
              type: TYPES.SET_PRODUCT,
              payload: {...product, popmart_sell_price: e.target.value}
            })}
            value={product.popmart_sell_price}
          />

          {errors?.popmart_sell_price && (
            <div className="fs-7 mb-7 text-danger">{errors.popmart_sell_price}</div>
          )}
        </div>
      )}

      <div className="mb-10 row">
        <div className="mt-5 col-xxl-4 col-xl-5 offset-xxl-1 offset-xl-1"><label className="form-label">Sale start
          date</label>
          <input type="datetime-local"
                 name="sale_start_date"
                 className="form-control"
                 value={product.sale_start_date || ''}
                 onChange={e => dispatch({
                   type: TYPES.SET_PRODUCT,
                   payload: {...product, sale_start_date: e.target.value}
                 })}
          />
          {errors?.sale_start_date && (
            <div className="fs-7 mb-7 text-danger">{errors.sale_start_date}</div>
          )}</div>


        <div className="mt-5 col-xxl-4 col-xl-5 offset-xxl-2"><label className="form-label">Sale end date</label>
          <input type="datetime-local"
                 name="sale_end_date"
                 className="form-control"
                 value={product.sale_end_date || ''}
                 onChange={e => dispatch({
                   type: TYPES.SET_PRODUCT,
                   payload: {...product, sale_end_date: e.target.value}
                 })}
          />
          {errors?.sale_end_date && (
            <div className="fs-7 mb-7 text-danger">{errors.sale_end_date}</div>
          )}</div>
      </div>
    </>
  );
}